export const GroupsTooltip = () => (
  <>Security or Office365 groups from Bayer AzureAD.</>
);
